/*************************************************************************
* ADOBE SYSTEMS INCORPORATED
*  Copyright 2016 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  Adobe permits you to use, modify, and distribute this file in
* accordance with the terms of the Adobe license agreement accompanying it.
* If you have received this file from a source other than Adobe, then your
* use, modification, or distribution of it requires the prior written
* permission of Adobe.
**************************************************************************/

/*jslint node:true, nomen:true, maxlen:120, plusplus:true */
/*global */
'use strict';

/**
 * AdobeDC utility functions and constructors.
 */

// Reuse and extend an existing global AdobeDC if it exists.
var AdobeDC = global.AdobeDC || {},
    hasMessageInStack = String(new Error("asdf").stack).indexOf("asdf") !== -1;

// Turn object details into JSON as needed.
function detailString(details) {
    return typeof details === 'object' ? JSON.stringify(details) : details;
}

/**
 * AdobeDC.AdobeError class
 * Enhanced Error to capture not only message, e.g. "Bad Request",
 * but also capture code (e.g. 400) and details (e.g. {headers, content}).
 */
function AdobeError(message, code, details) {
    this.code = code;
    this.message = message;
    this.details = details;
    var err = new Error(message +
        (code !== undefined ? " (" + code + ")" : "") +
        (details !== undefined ? "\nDetails: " + detailString(details) : ""));
    // Improve stack trace message, at least useful on Chrome/NodeJS.
    // .stack is not available on MSIE 10-11.
    err.name = this.name;
    if (err.stack) {
        if (hasMessageInStack) {
            this.stack = err.stack;
        } else {
            // Fix Firefox and anything else missing the message in the stack.
            this.stack = this.name + ": " + err.message + "\n" + err.stack;
        }
    }
}
AdobeDC.AdobeError = AdobeError;
Object.assign(AdobeError, {
    // this.constructor.constructor.apply(this) like super.apply(this)
    constructor: Error
}).prototype = Object.assign(Object.create(Error.prototype), {
    // prototype inheritance
    constructor: AdobeError,
    name: "AdobeError",
    toString: function (debug) {
        return this.name + ": " + this.message +
            (this.code !== undefined ? " (" + this.code + ")" : "") +
            (debug && this.details !== undefined ? "\nDetails: " + detailString(this.details) : "") +
            (debug && this.stack !== undefined ? "\nStack: " + this.stack : "");
    }
});

module.exports = AdobeDC;
